import { Check } from "lucide-react";
import { useNotify } from "ra-core";
import type { ReactNode } from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { getSupabaseClient } from "../../providers/supabase/supabase";
import type { WelcomeCall } from "./welcome";

const OPTIONS: { value: WelcomeCall["plan_override"]; label: string }[] = [
  { value: null, label: "Automático (según Stripe)" },
  { value: "sell", label: "Con venta del plan" },
  { value: "welcome_only", label: "Solo bienvenida" },
];

/** Admins: decide whether the welcome call sells the plan or not. */
export const PlanChoice = ({
  call,
  onChanged,
  children,
}: {
  call: WelcomeCall;
  onChanged: () => void;
  children: ReactNode;
}) => {
  const notify = useNotify();
  const choose = async (value: WelcomeCall["plan_override"]) => {
    const { error } = await getSupabaseClient().rpc("gula_welcome_set_plan", {
      p_call_id: Number(call.id),
      p_mode: value ?? null,
    });
    if (error) {
      notify(error.message, { type: "error" });
      return;
    }
    notify("Guardado", { type: "success" });
    onChanged();
  };
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="w-fit text-left outline-none">
        {children}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.label}
            onClick={() => choose(option.value)}
            className="flex items-center gap-2"
          >
            <Check
              className={`h-4 w-4 ${
                (call.plan_override ?? null) === option.value
                  ? "opacity-100"
                  : "opacity-0"
              }`}
            />
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
